import React from 'react';
import * as _ from 'lodash';
import {
  DragSourceAndDropTarget,
  DragAndDropSpace,
} from '../../components/DnDWrapper';
import {
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../CommonFormComponents';
import { messageUtility } from '../../utilities/messageUtility';
import Tippy, { ToolTip } from '../ReactTippy';

/**
 * 現場配置計画 - テーブル
 *
 * @param {*} {
 *   constructionPlacementPlaces,
 *   parentPlaces,
 *   values,
 *   errors,
 *   isSettingId,
 *   canDrag,
 *   callbacks,
 * }
 * @returns
 */
export const ConstructionPlacementPlaceContents = ({
  constructionPlacementPlaces,
  parentPlaces,
  values,
  errors,
  isSettingId,
  canDrag,
  canEdit,
  callbacks,
  isLoading,
}) => {
  const DndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return DndSpace(
    <div className='contructon-layout-list__list'>
      <table className='table'>
        <thead className='table__header'>
          <tr className='table__label table__label--contruction-layout-list-table'>
            <td className='value-table__label--parent'>
              <div className='value-table__label' />
            </td>
            <td className='value-table value-table__label--btn-drag'>
              <div className='value-table__label' />
            </td>
            <td className='value-table value-table--table__label value-table__label--name'>
              <div className='value-table__label'>場所名</div>
            </td>
            <td className='value-table value-table--table__label value-table__label--name'>
              <div className='value-table__label'>親階層</div>
            </td>
            <td className='value-table value-table--table__label'>
              <div className='value-table__label'>更新者</div>
            </td>
            <td className='value-table value-table--table__label'>
              <div className='value-table__label'>更新日時</div>
            </td>
            <td className='value-table value-table--table__label'>
              <div className='value-table__label' />
            </td>
          </tr>
        </thead>
        <tbody>
          {isSettingId === 0 ? (
            <ConstructionPlacementPlaceRegister
              key={0}
              values={values}
              errors={errors}
              parentPlaces={parentPlaces}
              callbacks={callbacks}
              canEdit={canEdit}
            />
          ) : null}
          {constructionPlacementPlaces.map(
            (constructionPlacementPlace, index) => {
              return isSettingId === constructionPlacementPlace.id ? (
                <ConstructionPlacementPlaceRegister
                  key={constructionPlacementPlace.id}
                  values={values}
                  errors={errors}
                  hasChildren={constructionPlacementPlace.hasChildren}
                  parentPlaces={parentPlaces}
                  callbacks={callbacks}
                  canEdit={canEdit}
                />
              ) : (
                <ConstructionPlacementPlace
                  key={constructionPlacementPlace.id}
                  constructionPlacementPlace={constructionPlacementPlace}
                  callbacks={callbacks}
                  canDrag={canDrag}
                  canEdit={canEdit && isSettingId === null ? true : false} // [BLDE_V2-46524]アカウント権限 協力会社管理者・職長の場合には「編集」ボタンが表示されないように
                  index={index}
                />
              );
            }
          )}
        </tbody>
      </table>
      {isLoading && <div className='indicator' />}
      {!isLoading &&
      constructionPlacementPlaces.length === 0 &&
      isSettingId === null ? (
        <div className='table-has-no-data'>
          <div className='table-has-no-data__message'>
            {messageUtility.getMessage('I-000-005')}
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export const ConstructionPlacementPlace = ({
  constructionPlacementPlace,
  callbacks,
  canDrag,
  canEdit,
  index,
}) => {
  const DndSrcTgt = element => {
    if (canDrag) {
      return (
        <DragSourceAndDropTarget
          id={`placeDnD`}
          index={index}
          data={constructionPlacementPlace}
          onHover={callbacks.dnd.onHover.bind(this)}
          onBeginDrag={callbacks.dnd.onBeginDrag.bind(this)}
          onDropped={callbacks.dnd.onDropped.bind(this)}
          canDrag={true}
          canDrop={true}
        >
          {element}
        </DragSourceAndDropTarget>
      );
    }

    return element;
  };

  return DndSrcTgt(
    <tr
      id={`construction-placement-place-${constructionPlacementPlace.id}`}
      className='table__item enable table__item--contruction-layout-list-table'
      onClick={() => {
        if (!canDrag) {
          callbacks.form.editLayout(constructionPlacementPlace.id);
        }
      }}
    >
      <td
        className={
          !constructionPlacementPlace.parent_id
            ? 'value-table__parent'
            : 'value-table__child'
        }
      />
      <td className='value-table value-tabe__btn-drag'>
        <button
          className='btn-icon--sm'
          style={{ display: canDrag ? 'inline-block' : 'none' }}
        >
          <i className='i-drag i-4x' />
        </button>
      </td>
      <td className='value-table value-table__name'>
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={<ToolTip>{constructionPlacementPlace.name}</ToolTip>}
        >
          <div className='value-table__txt--10 value-table__data--name'>
            {constructionPlacementPlace.name}
          </div>
        </Tippy>
      </td>
      <td className='value-table value-table__parent_name'>
        <Tippy
          duration={10}
          distance={24}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={<ToolTip>{constructionPlacementPlace.parent_name}</ToolTip>}
        >
          <div className='value-table__txt--6 value-table__data--name'>
            {constructionPlacementPlace.parent_name}
          </div>
        </Tippy>
      </td>
      <td className='value-table value-table__parent_name'>
        <div className='value-table__txt--6'>
          {constructionPlacementPlace.updater_name}
        </div>
      </td>
      <td className='value-table value-table__parent_name'>
        <div className='value-table__txt--6'>
          {constructionPlacementPlace.updated}
        </div>
      </td>
      <td className='value-table value-table__edit-button'>
        <ul className='list-menu'>
          <li className='list-menu__item'>
            {canEdit && (
              <button
                className='btn--sm--stay'
                onClick={e => {
                  e.stopPropagation();
                  callbacks.form.setFormValues(constructionPlacementPlace);
                }}
                style={{ display: canDrag ? 'none' : 'inline-block' }}
              >
                編集
              </button>
            )}
          </li>
        </ul>
      </td>
    </tr>
  );
};

const getErrorMessaage = (errors, column) => {
  if (errors[column]) {
    return <div className='validate-message show'>{errors[column]}</div>;
  } else {
    return null;
  }
};

export const ConstructionPlacementPlaceRegister = ({
  values,
  errors,
  parentPlaces,
  hasChildren,
  callbacks,
  canEdit,
}) => (
  <tr
    id={`construction-placement-place-register-${values.id}`}
    className='table__item editable table__item--contruction-layout-list-table'
  >
    <td className='value-table__parent' />
    <td className='value-table value-tabe__btn-drag' />
    <td className='value-table value-table__name'>
      <div className='value-table__place_box'>
        <input
          type='text'
          name='name'
          className='textarea-contruction-list'
          value={values.name}
          maxLength={64}
          onChange={e => callbacks.form.set(e)}
          onBlur={e => callbacks.form.validate(e)}
        />
        {getErrorMessaage(errors, 'name')}
      </div>
    </td>
    <td className='value-table value-table__parent_name set-width-dropdown'>
      {!hasChildren ? (
        <ParentPlaceDropdown
          name='parent_id'
          placeId={values.id}
          list={parentPlaces}
          value={values.parent_id}
          changeEvent={callbacks.form.setDropdown.bind(this)}
          isOptional={true}
        />
      ) : null}
    </td>
    <td className='value-table value-table__parent_name' />
    <td className='value-table value-table__parent_name' />
    <td className='value-table value-table__edit-button'>
      <ul className='list-menu'>
        {/* 削除対象の場所に親階層が指定されている場合削除不可 && ログインユーザーが協力会社ユーザーの場合削除不可
         新規作成時に削除ボタンを表示しない*/}
        {values.id && hasChildren === true ? null : _.isNil(
            values.id
          ) ? null : canEdit === false ? null : (
          <li className='list-menu__item'>
            <button
              className='btn--sm--negative'
              onClick={() => callbacks.modal.deleteModal(values.id, callbacks)}
            >
              削除
            </button>
          </li>
        )}

        <li className='list-menu__item'>
          <button
            className='btn--sm--sub'
            onClick={callbacks.form.clearFormValues}
          >
            戻る
          </button>
        </li>
        <li className='list-menu__item'>
          <button
            className='btn--sm--effective'
            type='submit'
            disabled=''
            onClick={() => callbacks.form.submit(values)}
          >
            保存
          </button>
        </li>
      </ul>
    </td>
  </tr>
);

class ParentPlaceDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showForm: false,
      searchWord: '',
      list: this.props.list,
      selectId: 0,
    };

    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.clearSelectedRow = this.clearSelectedRow.bind(this);
  }

  componentDidMount() {}

  handleShowForm() {
    this.setState({
      showForm: !this.state.showForm,
      selectId: this.props.value,
    });
  }

  onChangeSearchWord(e) {
    this.updateList(e.target.value);
    this.setState({
      searchWord: e.target.value,
    });
  }

  updateList(searchWord) {
    let list = this.props.list;
    if (searchWord !== '') {
      list = _.filter(list, item => {
        return item.name.indexOf(searchWord) >= 0;
      });
    }
    this.setState({
      selectId: 0,
      list,
    });
  }

  handleSelectedRow(selectId) {
    this.setState({ selectId }, () => {
      this.onClickSelect();
    });
  }

  clearSelectedRow = () => {
    this.setState({ selectId: 0 }, () => {
      this.onClickSelect();
    });
  };

  onClickSelect() {
    this.props.changeEvent(this.props.name, this.state.selectId);
    this.setState({
      showForm: false,
    });
  }

  render() {
    const getDropdownLabel = () => {
      let label = `場所名`;
      if (this.props.value !== '') {
        _.each(this.props.list, item => {
          if (item.id === this.props.value) {
            label = item.name;
          }
        });
      }
      return label;
    };

    const dropdownWidth = {
      width: '100%',
    };

    return (
      <div
        id='form-parent-place-dropdown'
        className='dropdown-single-select select-parent-place --col-xs-6 --col-md-6 --col-lg-6 --col-xl-6'
        style={dropdownWidth}
      >
        <div
          className='dropdown-single-select__header'
          onClick={() => this.handleShowForm()}
        >
          <input name='parent_id' type='hidden' value='' />
          <a id='fform-parent-place-dropdown-btn' className='dropdown-select'>
            <span className='dropdown-select__txt parent_place_name'>
              {getDropdownLabel()}
            </span>
          </a>
        </div>
        <div
          className={`dropdown dropdown--dropdown-single-select ${
            this.state.showForm ? 'show' : ''
          }`}
        >
          <div className='dropdown__item'>
            <div className='dropdown-single-select__item'>
              <i className='i-search i-2x' />
              <input
                type='text'
                className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                placeholder={messageUtility.getMessage('I-000-090')}
                onChange={e => this.onChangeSearchWord(e)}
              />
            </div>
            {this.props.isOptional && (
              <div className='dropdown-single-select__item'>
                <FormDropdownClearButton onClick={this.clearSelectedRow} />
              </div>
            )}
            <div className='dropdown-single-select__scroll'>
              <ul className='single-select copy-place-list'>
                {_.map(this.state.list, (option, index) =>
                  option.id !== this.props.placeId ? (
                    <FormDropdownRadio
                      key={index}
                      option={option}
                      checked={this.state.selectId === option.id}
                      targetId={this.id}
                      handleSelectedRow={this.handleSelectedRow}
                    >
                      {option.name}
                    </FormDropdownRadio>
                  ) : null
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tables/ConstructionPlacementPlace.jsx